import { RevoltModal, RevoltButton } from '../../../components';
import './EntryFileErrorModal.css';

export function EntryFileErrorModal({
  isOpen,
  onClose,
  filePath
}) {
  // Normalize path for display: always starts with a single slash
  const displayPath = filePath 
    ? (filePath.startsWith('/') ? filePath : `/${filePath}`)
    : '/unknown';

  return (
    <RevoltModal
      isOpen={isOpen}
      onClose={onClose}
      title="Entry File Not Found"
      containerClassName="entry-file-error-modal"
    >
      <div className="entry-file-error-content">
        <div className="entry-file-error-icon">
          <i className="fa-solid fa-file-circle-question"></i>
        </div>
        <p className="entry-file-error-message">
          The entry file for this application could not be found at the specified path.
        </p>
        <div className="entry-file-error-path">
          <span className="entry-file-error-path-label">Path:</span>
          <code className="entry-file-error-path-value">{displayPath}</code>
        </div>
        <p className="entry-file-error-hint">
          Please check the entry file path in the app settings. The file may have been moved, deleted, or the path may contain a typo.
        </p>
        <div className="entry-file-error-actions">
          <RevoltButton variant="accent" onClick={onClose}>
            Close
          </RevoltButton>
        </div>
      </div>
    </RevoltModal>
  );
}

